import { PurchaseFinalizeDTO } from '../../../mappers/purchase/finalize/types';
import { PurchaseFormValues } from '../../../types/purchases/BasePurchase';

export const mapImportPurchase = (form: PurchaseFormValues): PurchaseFinalizeDTO => {
  return {
    comments: form.comments?.trim() || '',
    paymentCondition: null,
    paymentMethod: null,
    individualPayments: null,
  };
};
